import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { PopupFactory } from '../popup-factory';
import { ResizableEvent } from '../../directives/resizable/resizable.directive';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-globalexceptionhandler-popup',
  templateUrl: './globalexceptionhandler-popup.component.html',
})
export class GlobalExceptionHandlerPopupComponent implements OnInit, AfterViewChecked {
  @ViewChild('globalExceptionHandlerPopupId') globalExceptionHandlerPopupId: ElementRef;
  @ViewChild('globalExceptionHandlerPopupHeader') globalExceptionHandlerPopupHeader: ElementRef;
  @ViewChild('globalExceptionHandlerPopupBody') globalExceptionHandlerPopupBody: ElementRef;
  @ViewChild('globalExceptionHandlerPopupFooter') globalExceptionHandlerPopupFooter: ElementRef;

  @Input() title: string;
  @Input() scrollTop: boolean;
  @Input() backdrop: boolean;
  @Input() selectedItemsLength: number;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  popupFactory: PopupFactory;

  message: string;
  stack: string;
  constructor(private element: ElementRef) {
    this.popupFactory = new PopupFactory();
    this.scrollTop = true;
    this.backdrop = true;
  }

  ngOnInit(): void {
    const modals = document.querySelectorAll('.ui-modal');
    this.popupFactory.disablePopupBackground(modals);
  }

  ngAfterViewChecked(): void {
    this.popupFactory.restorePopup(this.globalExceptionHandlerPopupId.nativeElement);
  }

  setDefaults(): void {
    this.message = "";
    this.stack = "";
  }

  show(error: any): void {
    this.popupFactory.executePostDisplayActions = true;
    this.popupFactory.visible = true;
    this.center();

    this.setDefaults();

    if( error instanceof HttpErrorResponse ) {
      this.title = error.statusText;
      this.message = error.message;
      
      switch (error.status) {
        case 404:
          this.stack = "Page Not Found";
          break;
        case 504:
          this.stack = error.statusText;
        default:
          this.stack = error.error;
          break;
      }
    } else {
      this.title = "Type Error";
      this.message = error.message;
      this.stack = error.stack;
    }
  }

  closePopup(): void {
    this.popupFactory.visible = false;
    this.close.emit(true);
  }

  center() {
    this.popupFactory.center(this.globalExceptionHandlerPopupId.nativeElement);
  }

  onCloseIcon(event: Event) {
    event.stopPropagation();
  }

  onResize(event: ResizableEvent) {
    this.popupFactory.onResize(event, this.globalExceptionHandlerPopupHeader.nativeElement,
      this.globalExceptionHandlerPopupFooter.nativeElement, this.globalExceptionHandlerPopupId.nativeElement,
      this.globalExceptionHandlerPopupBody.nativeElement);
  }

  toggleMaximize(event) {
    this.popupFactory.toggleMaximize(event, this.globalExceptionHandlerPopupHeader.nativeElement,
      this.globalExceptionHandlerPopupFooter.nativeElement, this.globalExceptionHandlerPopupId.nativeElement,
      this.globalExceptionHandlerPopupBody.nativeElement);
  }
}